/**
 * search page about action & creator
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/7
 */
export const GET_PRODUCT_BY_QUERY = 'GET_PRODUCT_BY_QUERY';
export const RECEIVE_QUERY_PRODUCT = 'RECEIVE_QUERY_PRODUCT';
export const GET_SEARCH_TIP = 'GET_SEARCH_TIP';
export const RECEIVE_SEARCH_TIP = 'RECEIVE_SEARCH_TIP';

/**
 * search product data by query & page
 * @param  {string} query      query key
 * @param  {number} current    current page
 * @return {object}
 */
export const getProductByQuery = (query, current) => ({
  type: GET_PRODUCT_BY_QUERY,
  query,
  current
})

/**
 * receive query product result
 * @param  {object} product 
 * @return {object}
 */
export const receiveQueryProduct = (product) => ({
  type: RECEIVE_QUERY_PRODUCT,
  product
})

export const getSearchTip = (query) => ({
  type: GET_SEARCH_TIP,
  query
})

export const receiveSearchTip = (searchTip) => ({
  type: RECEIVE_SEARCH_TIP,
  searchTip
})


// WEBPACK FOOTER //
// ./src/actions/search.js